module.exports = __webpack_public_path__ + "img/2400.2803899c.jpg";